import { Modal } from '@root/src/components/common';
import {
  useCallback,
  useState,
} from 'react';
import { useUrlChange } from '@root/src/utils/url/useUrlChange';
import { useExtendedRouter } from '@root/src/hooks/next-routing-wrappers';
import { CvDetailHub } from '../../cv/CvDetailHub';

export interface ChatTalentModalProps {
  talentsArray: {
    items: ApiSchema<'ResumeCardData'>[] | undefined
  }[] | undefined
}

const ChatTalentModal = (props: ChatTalentModalProps) => {
  // Destructure props
  const { talentsArray } = props;
  const { withLocale } = useExtendedRouter();

  const openTalentModal = useCallback((userSlug: string, as: string | undefined) => {
    // Set the navigation URL with the CV link
    window.history.pushState(null, '', withLocale(as ? `${as}?selectedCvSlug=${userSlug}` : ''));
  }, [withLocale]);


  const [selectedCvSlugQueryParam, setSelectedCvSlug] = useState<string | null>(null);

  // Function to check if the selectedCvSlug exists in the URL
  const checkSelectedCvSlug = (url: string) => {
    // If the URL is relative, combine it with the current origin to make it absolute
    const absoluteUrl = url.startsWith('http') ? url : `${window.location.origin}${url}`;

    // Create a new URL object
    const { searchParams } = new URL(absoluteUrl);

    // Return the value of the 'selectedCvSlug' parameter, or null if it's not found
    return searchParams.get('selectedCvSlug');
  };

  // Detect URL changes and check for selectedCvSlug
  useUrlChange((newUrl: string) => {
    const cvSlug = checkSelectedCvSlug(newUrl);
    setSelectedCvSlug(cvSlug); // Update the state with the slug
  });

  const [currentListUrl] = useState<string>(typeof window !== 'undefined' ? window.location.href : '');

  const closeCvModal = () => {
    // Use window.history.replaceState to update the URL without adding a new history entry
    window.history.replaceState(null, '', currentListUrl);
  };

  return (
    <>
      {selectedCvSlugQueryParam && (
        <Modal
          isOpen
          onClose={closeCvModal}
          size="full"
          className="!transform-none !overflow-visible"
          body={(
            <>
              <CvDetailHub
                slug={selectedCvSlugQueryParam}
                isAuthenticated
                closeModal={closeCvModal}
                swrTalentList={talentsArray}
                openTalentModal={openTalentModal}
                size={talentsArray?.length}
                showLoadMore={false}
              />
            </>
          )}
        />
      )}
    </>
  );
};

export default ChatTalentModal;
